import { CountUp } from 'countup.js';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';

const initSwiper = () => {
    const swiperDisableBreakpoint = window.matchMedia('(min-width: 1024px)');
    let swiperInstance;

    const breakpointChangeEventListener = () => {
        if (swiperDisableBreakpoint.matches) {
            if (swiperInstance) {
                swiperInstance.destroy();
            }

            return;
        }

        enableSwiper();
    };

    const enableSwiper = () => {
        swiperInstance = new Swiper('.swiper', {
            modules: [Pagination],

            direction: 'horizontal',
            loop: false,

            slidesPerView: 1.7,
            centeredSlides: true,
            spaceBetween: 0,

            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    };

    swiperDisableBreakpoint.addEventListener('change', breakpointChangeEventListener);
    breakpointChangeEventListener();
};

const initCounterUp = () => {
    const intersectEventListener = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const counterBikes = new CountUp('counter_bikes', 18000);
                counterBikes.start();

                const counterCars = new CountUp('counter_cars', 113000, {
                    duration: 3,
                });
                counterCars.start();

                const counterVisitors = new CountUp('counter_visitors', 4, {
                    startVal: 1,
                    duration: 3,
                    useEasing: false,
                });
                counterVisitors.start();

                observer.unobserve(entry.target);
            }
        });
    };

    const observer = new IntersectionObserver(intersectEventListener, { threshold: 0.5 });
    const observable = document.getElementById('counter_up_intersection_trigger');

    observer.observe(observable);
};

initSwiper();
initCounterUp();
